export default "__VITE_ASSET__D1bHDT3C__"